import { Button, Form, Grid, Input } from 'antd';
import { ContentFilters } from 'components';
import { StandardItemsWrapper } from 'components/content-filters/content-filters.styles';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { FieldsFilterFormField, FieldsFilterFormValues } from './types';

const { useBreakpoint } = Grid;

type FieldsFilterFormProps = {
  formId: string;
  handleFilter: (values: FieldsFilterFormValues) => void;
  initialValues: FieldsFilterFormValues;
  closeModal?: () => void;
};

export const FieldsFilterForm = ({
  formId,
  handleFilter,
  initialValues,
  closeModal,
}: FieldsFilterFormProps) => {
  const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
  const [form] = Form.useForm<FieldsFilterFormValues>();
  const { t } = useTranslation();
  const screens = useBreakpoint();

  const onReset = () => {
    form.resetFields();
  };

  const handleOnFinish = (values: FieldsFilterFormValues) => {
    handleFilter(values);
    closeModal?.();
  };

  return (
    <Form<FieldsFilterFormValues>
      id={formId}
      name={formId}
      form={form}
      layout='vertical'
      onFinish={handleOnFinish}
      initialValues={initialValues}
      onFinishFailed={() => {
        setValidateTrigger(['onChange']);
      }}
      validateTrigger={validateTrigger}
    >
      <ContentFilters.FormItemsWrapper>
        <StandardItemsWrapper>
          <Form.Item<FieldsFilterFormValues>
            label={t('fields.formFields.fieldName.label')}
            name={FieldsFilterFormField.FieldName}
          >
            <Input placeholder={t('fields.formFields.fieldName.placeholder')} />
          </Form.Item>
        </StandardItemsWrapper>
      </ContentFilters.FormItemsWrapper>

      {screens.lg && (
        <ContentFilters.ButtonsWrapper>
          <Button type='primary' htmlType='submit'>
            {t('fields.buttons.filter', { count: 1 })}
          </Button>
          <Button onClick={onReset}>{t('fields.buttons.reset')}</Button>
        </ContentFilters.ButtonsWrapper>
      )}
    </Form>
  );
};
